import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { KineticLines, Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/images";

export default function StoreExperience() {
  return (
    <section className="bg-cream py-16 md:py-24" data-testid="store-experience-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-rific md:text-xs">The RIFIC Store</p>
            </Reveal>
            <KineticLines
              lines={["A STORE PEOPLE", "NOTICE."]}
              className="mt-3 block"
              lineClassName="font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em] text-deep"
            />
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <p className="font-display text-2xl font-bold leading-snug tracking-[-0.01em] text-deep md:text-3xl">
                Bold outside.
                <br />
                Warm inside.
                <br />
                <span className="text-orange-rific">Unmistakably RIFIC.</span>
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-12 md:mt-16">
          <div className="overflow-hidden rounded-[28px] bg-cream">
            <img
              src={IMG.storefront}
              alt="RIFIC 15 ft storefront — bold orange exterior with deep green branding and the RIFIC leaf"
              loading="lazy"
              className="h-auto w-full object-contain"
            />
          </div>
        </Reveal>

        <Reveal delay={0.16} className="mt-5 md:mt-6">
          <div className="mx-auto max-w-md overflow-hidden rounded-[28px] bg-cream">
            <img
              src={IMG.storefrontPortrait}
              alt="RIFIC compact 10 ft storefront with rounded geometry and premium lighting"
              loading="lazy"
              className="h-auto w-full object-contain"
            />
          </div>
        </Reveal>

        <Reveal delay={0.1} className="mt-10 text-center">
          <Link
            to="/our-story"
            data-testid="store-experience-explore-cta"
            className="inline-flex h-14 items-center gap-2 rounded-full bg-deep px-9 text-sm font-bold uppercase tracking-[0.16em] text-cream transition-colors duration-300 hover:bg-orange-rific"
          >
            Explore RIFIC
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
